'use client'

import { Box, Flex, Text, VStack } from '@chakra-ui/react'
import { ContentContainer } from 'ui'
import { keyframes } from '@emotion/react'
import { FC } from 'react'
import { SectionLabel, SectionTitle } from '../_components/granditude'
import Image from 'next/image'

import fortnoxLogo from '#/src/images/partners/fortnox-logo.svg'
import ongoingLogo from '#/src/images/partners/ongoing-logo.svg'
import nshiftLogo from '#/src/images/partners/nshift-logo.svg'
import postnordLogo from '#/src/images/partners/postnord-logo.svg'
import nexiLogo from '#/src/images/partners/nexi-logo.svg'
import zettleLogo from '#/src/images/partners/zettle-logo.svg'
import googleShoppingLogo from '#/src/images/partners/google-shopping-logo.png'
import prisjaktLogo from '#/src/images/partners/prisjakt-logo.svg'
import elongroupLogo from '#/src/images/partners/elongroup-logo.png'
import kustomLogo from '#/src/images/partners/kustom-logo.svg'

const scrollLogos = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`

const integrations = [
  { name: 'Fortnox', logo: fortnoxLogo },
  { name: 'Ongoing WMS', logo: ongoingLogo },
  { name: 'nShift', logo: nshiftLogo },
  { name: 'PostNord', logo: postnordLogo },
  { name: 'Nexi', logo: nexiLogo },
  { name: 'Zettle', logo: zettleLogo },
  { name: 'Google Shopping', logo: googleShoppingLogo },
  { name: 'Prisjakt', logo: prisjaktLogo },
  { name: 'Elon Group', logo: elongroupLogo },
  { name: 'Kustom', logo: kustomLogo }
]

// Duplicate for seamless loop
const allIntegrations = [...integrations, ...integrations]

export const IntegrationsSection: FC = () => {
  return (
    <Box as="section" w="100%" py={{ base: 16, md: 32 }} bg="background.surface">
      <ContentContainer mb={10}>
        <VStack w="100%" textAlign="center" spacing={0}>
          <SectionLabel>Integrations</SectionLabel>
          <SectionTitle>We work with your tools</SectionTitle>
          <Text fontSize="1.1rem" color="text.secondary" maxW="600px" mx="auto">
            You&apos;ve already invested in systems that partly work. We don&apos;t rip and replace
            — we connect, sync, and make them work together properly.
          </Text>
        </VStack>
      </ContentContainer>

      <Box
        overflow="hidden"
        sx={{
          maskImage: 'linear-gradient(to right, transparent, black 5%, black 95%, transparent)',
          WebkitMaskImage:
            'linear-gradient(to right, transparent, black 5%, black 95%, transparent)'
        }}
      >
        <Flex
          gap={12}
          alignItems="center"
          w="max-content"
          animation={`${scrollLogos} 40s linear infinite`}
          _hover={{ animationPlayState: 'paused' }}
        >
          {allIntegrations.map((integration, index) => (
            <Box
              key={index}
              flexShrink={0}
              h="40px"
              display="flex"
              alignItems="center"
              // the second copy only exists for the loop
              aria-hidden={index >= integrations.length || undefined}
            >
              <Image
                src={integration.logo}
                alt={integration.name}
                height={40}
                style={{ width: 'auto', height: '40px', objectFit: 'contain' }}
              />
            </Box>
          ))}
        </Flex>
      </Box>
    </Box>
  )
}
